import { defineStore, storeToRefs } from "pinia";
import api from "@/services/api";
import {useAuthStore, useSessionStore} from '@/stores';
import type IStockLevel from "@/models/responses/IStockLevel";

export const useStockLevelsStore = defineStore("stockLevels", {
  state: () => ({
    stockLevels: [] as IStockLevel[],
    error: "" as any,
    loadedSiteId: 0,
  }),
  actions: {
    async fetchAll(force = false) {
      const authStore = useAuthStore();
      const sessionStore = useSessionStore();

      const { isAuthenticated } = storeToRefs(authStore);
      const { selectedSiteId } = storeToRefs(sessionStore);

      if (!isAuthenticated.value) return;
      if (!force && this.loadedSiteId === selectedSiteId.value) return;

      this.stockLevels = [];
      this.error = "";
      await api
        .get<IStockLevel[]>(`v1.0/stock-levels?siteId=${selectedSiteId.value}`)
        .then((response) => {
          this.stockLevels = response.data;
          this.loadedSiteId = selectedSiteId.value;
         })
        .catch((error) => this.error = error);
    },
    async updateItemDemand(stockLevelId: number, minQuantity: number, maxQuantity: number) {
      const authStore = useAuthStore();
      const { isAuthenticated } = storeToRefs(authStore);
      if (!isAuthenticated.value) return;

      this.error = "";
      const url = "v1.0/stock-levels/" + stockLevelId;
      const updateRequest = { minQuantity, maxQuantity };

      await api.put(url, updateRequest);
    },
  },
  getters: {
    getByItemId: (state) => (itemId: number): IStockLevel => {
      return <IStockLevel>state.stockLevels.find((sl) => sl.itemId === itemId);
    },
  },
});
